import './styles.css';

export function Pill({ variant = 'default', className = '', children, ...rest }) {
  const variantClass =
    variant === 'blue' ? 'pillBlue' : variant === 'green' ? 'pillGreen' : variant === 'dark' ? 'pillDark' : '';
  const classes = ['pill', variantClass, className].filter(Boolean).join(' ');

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

